import clsx from 'clsx'
import React from 'react'
import { useIntl } from 'react-intl'

import s from './styles.module.scss'

interface ISwitchButtonProps {
  value: boolean
  setValue: (value: boolean) => void
  disabled?: boolean
  className?: string
}

const SwitchButton = ({
  value = false,
  setValue,
  disabled = false,
  className,
}: ISwitchButtonProps) => {
  const intl = useIntl()
  return (
    <div
      className={clsx(
        s.switch,
        className,
        { [s.checked]: value },
        { [s.disable]: disabled },
      )}
      onClick={(e) => {
        e.stopPropagation()
        if (!disabled) {
          setValue(!value)
        }
      }}
    >
      <div className={s.container}>
        <span>
          {value
            ? intl.formatMessage({
                id: 'ui.SwitchButton.yes',
                defaultMessage: 'Oui',
              })
            : intl.formatMessage({
                id: 'ui.SwitchButton.no',
                defaultMessage: 'Non',
              })}
        </span>
      </div>
      <div className={s.button}></div>
    </div>
  )
}

export default SwitchButton
